export { Category10 } from './category10';
export { Category20 } from './category20';
//# sourceMappingURL=index.js.map